import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0095',
    ecrans: ['00-2'],
    params: ['el3cleint']
});
